<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    document.title = this.$t('login.title')
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue